import React from 'react';



const MessagePopup = (props) => {

    const { data, title, isError } = props;
    const message = ((data ? data : 'An unknown error occurred') + '.');

    return (
        <div className="standard-popup-form">
            <div className="modal fade" id="messagePopup">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <div className="shared-modal-header">
                                <h4>{title ? title : 'Information'}</h4>
                            </div>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body">
                            <div className="contact-form-box">
                                <div className="db-box">
                                    <p className="modal-feedback">
                                        {message}
                                        {isError &&
                                            <>
                                                {' '}
                                                Please try again or <a className="red no-underline" href="/contactus" target="_blank" rel="noopener noreferrer"><u>contact us</u></a> if the error persists.
                                            </>
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default MessagePopup;